"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemCataloguePrice = void 0;
var _mui = require("@ori-ui/mui");
var _context = require("../../context");
var _hooks = require("../../hooks");
var _style = require("./style");
var _usePriceLogic = require("./usePriceLogic");
var _jsxRuntime = require("react/jsx-runtime");
const BasicCataloguePrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textDecoration: 'line-through',
  whiteSpace: 'nowrap',
  display: 'flex'
}));
const ItemCataloguePrice = () => {
  const {
    basicCataloguePrice,
    itemTestId,
    priceName
  } = (0, _context.useItemContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    priceLogic
  } = (0, _usePriceLogic.usePriceLogic)();
  const {
    regularPrice,
    showCataloguePrice,
    showBasicCataloguePrice
  } = priceLogic;
  const theme = (0, _mui.useTheme)();
  if (showCataloguePrice) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.NumberInner, {
      "data-testid": `${itemTestId}-cataloguePrice`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.NumberInnerValue, {
          variant: "caption",
          color: theme.palette.text.secondary,
          children: [priceName ? translations[priceName] : translations.regularPrice, ":"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.NumberInnerValue, {
          variant: "caption",
          color: theme.palette.text.secondary,
          children: regularPrice
        })]
      }), showBasicCataloguePrice ? /*#__PURE__*/(0, _jsxRuntime.jsx)(BasicCataloguePrice, {
        variant: "caption",
        color: theme.palette.text.secondary,
        children: basicCataloguePrice
      }) : null]
    });
  }
  return null;
};
exports.ItemCataloguePrice = ItemCataloguePrice;
